import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { useReader } from "../../context/ReaderContext";
import { Chips, usePMeta } from "./Chips";
import { track } from "../../lib/analytics";

const KEY = "bp-welcome-dismissed";
const QUICK = ["immigration", "family", "kindergeld", "employment", "taxes", "housing", "diaspora"];

// Shown to first-time visitors without a profile: 1) topics 2) state 3) show my news.
export const WelcomeCard = () => {
  const { reader, guest, setGuestProfile } = useReader();
  const m = usePMeta();
  const nav = useNavigate();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  const [interests, setInterests] = useState([]);
  const [state, setState] = useState("");
  const [store, setStore] = useState(false);
  if (hidden || reader !== false || guest?.profile || !m) return null;
  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setHidden(true);
  };
  const go = () => {
    setGuestProfile({ interests, state: state || null, nationalities: [], situations: [], personalization_enabled: true }, store);
    track("personalization_enabled");
    nav("/moje-vijesti");
  };
  const quick = Object.fromEntries(QUICK.map((k) => [k, m.interests[k]]));
  const step = (n, t) => <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-pulse-light"><span className="mr-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-pulse text-white">{n}</span>{t}</p>;
  return (
    <section className="container-news mt-8" data-testid="welcome-card">
      <div className="relative overflow-hidden bg-navy p-5 text-white sm:p-7 lg:grid lg:grid-cols-[260px_minmax(0,1fr)_240px] lg:gap-8">
        <button type="button" onClick={dismiss} aria-label="Zatvori" className="absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-full text-white/70 hover:bg-white/10 hover:text-white" data-testid="welcome-dismiss"><X className="h-4 w-4" /></button>
        <div className="pr-8">
          <p className="inline-flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.14em] text-pulse-light"><Sparkles className="h-3.5 w-3.5" /> Novo: Moj Balkan Info</p>
          <h2 className="mt-2 font-display text-[1.4rem] font-semibold leading-tight">Vijesti koje su važne baš tebi – u tri klika</h2>
          <p className="mt-2 text-[13.5px] text-white/70">Bez registracije. Ništa se ne sprema na naš server.</p>
        </div>
        <div className="mt-5 space-y-4 lg:mt-0">
          {step(1, "Odaberi teme")}
          <div className="[&_button]:border-white/25 [&_button]:bg-white/5 [&_button]:text-white [&_button[aria-pressed=true]]:border-pulse [&_button[aria-pressed=true]]:bg-pulse"><Chips options={quick} value={interests} onChange={setInterests} testId="welcome-topic" /></div>
          {step(2, "Gdje živiš? (opcionalno)")}
          <select value={state} onChange={(e) => setState(e.target.value)} aria-label="Savezna pokrajina" className="h-11 w-full max-w-sm rounded-sm border border-white/25 bg-navy px-3 text-[14px] text-white" data-testid="welcome-state">
            <option value="">— cijela Njemačka —</option>{Object.entries(m.states).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </div>
        <div className="mt-5 flex flex-col justify-end gap-3 lg:mt-0">
          {step(3, "Pogledaj")}
          <button type="button" onClick={go} disabled={!interests.length} className="inline-flex min-h-[46px] items-center justify-center rounded-sm bg-pulse px-5 text-sm font-bold text-white transition-colors hover:bg-pulse-dark disabled:opacity-50" data-testid="welcome-go">Prikaži moje vijesti</button>
          <label className="flex gap-2 text-[12px] text-white/70"><input type="checkbox" checked={store} onChange={(e) => setStore(e.target.checked)} className="mt-0.5" data-testid="welcome-store" />Zapamti u ovom pregledniku</label>
        </div>
      </div>
    </section>
  );
};
